// REAL output from an actual InkPhD Deep Writer run.
// Project: demo "Step-up vs open necrosectomy in necrotising pancreatitis" (8 indexed papers)
// Chapter 94c7e9c6-d5a4-446f-8170-5e3a614988e1 · section: Discussion · engine: multi (3 passes)
// Run metadata: outline 15.8 s · draft 91.4 s · verify 60.5 s · 4 subsections ·
// 3 294 words · 20 paragraphs verified · 7 citation tokens (6 verified, 1 unverified,
// trust 85.7 %) · 8 sources in the library.
export const RUN = {
  project: 'Step-up vs open necrosectomy in necrotising pancreatitis',
  section: 'Discussion',
  sources: 8,
  words: 3294,
  subsections: 4,
  paragraphsVerified: 20,
  citations: 7,
  verified: 6,
  unverified: 1,
  trust: 86,
  durations: { outline: '15.8 s', draft: '91.4 s', verify: '60.5 s' },
};

// Pass 1 — verbatim outline headings + the first key question the engine attached to each.
export const OUTLINE = [
  {
    heading: 'Paragraph 1 — Summary of principal findings',
    question:
      'What were the principal outcomes when comparing the minimally invasive step-up approach versus primary open necrosectomy in adults with infected necrotising pancreatitis, focusing on major complications and mortality?',
  },
  {
    heading: 'Paragraph 2 — Comparison with existing literature (agreement and divergence)',
    question:
      'How do the findings compare with trials that distinguish endoscopic versus surgical step-up strategies (TENSION; endoscopic transgastric vs surgical necrosectomy), and what elements of technique or care pathway could account for the differences?',
  },
  {
    heading: 'Paragraph 3 — Strengths and limitations of this study',
    question:
      'Which limitations could bias the observed association (confounding by indication, selection and performance bias, centre expertise, temporal changes in supportive care, crossover), and in which direction might they shift the effect estimates?',
  },
  {
    heading: 'Paragraph 4 — Clinical implications and future research',
    question:
      'What are the most defensible clinical implications for management pathways in infected necrotising pancreatitis, staying consistent with the AGA update and IAP/APA guidelines cited?',
  },
];

// Pass 2 — verbatim excerpt from the generated Discussion (citation tokens rendered as [1]/[2]).
export const DRAFT = {
  text: `The randomised evidence most directly addressing the first issue is PANTER, which compared a percutaneous-drainage-first step-up pathway with primary open necrosectomy and demonstrated a substantially lower risk of the composite endpoint of major complications or death with step-up (40% vs 69%; risk ratio 0.57; 95% CI 0.38 to 0.87; p = 0.006), while mortality was similar (19% vs 16%) and the between-group difference was largely explained by fewer new-onset multiple-organ failure events (12% vs 40%; p = 0.002) in the step-up arm.`,
  ref: '[1]',
  text2: `TENSION, a multicentre RCT comparing endoscopic step-up against surgical step-up, found no superiority of the endoscopic route on the primary composite of death or major complications (43% vs 45%; risk ratio 0.97; 95% CI 0.62 to 1.51; p = 0.88), with identical mortality (18% in both groups), but fewer pancreatic fistulas (5% vs 32%; p = 0.0011) and shorter hospital stay (mean 53 vs 69 days; p = 0.014) with endoscopic management.`,
  ref2: '[2]',
  refs: [
    '[1] van Santvoort HC, et al. A step-up approach or open necrosectomy for necrotizing pancreatitis. N Engl J Med. 2010. doi:10.1056/NEJMoa0908821',
    '[2] van Brunschot S, et al. Endoscopic or surgical step-up approach for infected necrotising pancreatitis. Lancet. 2018. doi:10.1016/S0140-6736(17)32404-2',
  ],
};

// Pass 3 — verbatim sentence the verification pass produced instead of overclaiming.
export const VERIFY = {
  gapSentence:
    'However, the provided evidence pack does not report whether PANTER\u2019s endpoint adjudication explicitly used Revised Atlanta (published later) criteria for organ failure duration or for classifying necrotic collections; therefore, alignment with Revised Atlanta is necessarily interpretive rather than formally validated within the trial.',
  unverifiedToken: '@doi:10.1016/S0140-6736',
};
